const InfoTwo = () => {
  return (
    <section className="info-two half-bg">
      <div className="container">
        <div className="bg-white box-shadow-md rounded-16 p-16">
          <div className="row gy-4 justify-content-center">
            <div
              className="col-xl-4 col-sm-6 col-md-4"
              data-aos="fade-up"
              data-aos-duration={400}
            >
              <div className="info-two-item flex-align animation-item h-100  border border-neutral-30 rounded-12 bg-main-25">
                <span className="flex-shrink-0">
                  <img
                    src="assets/images/icons/info-two-icon1.png"
                    className="animate__heartBeat"
                    alt=""
                  />
                </span>
                <div>
                  <h5 className="mb-16">Excellence in Education</h5>
                  <p className="text-neutral-700">
                    Experience world-class holistic education at NPS,
                    Kudlu—where academic excellence blends with values,
                    creativity, and character-building to nurture every child’s
                    full potential.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-xl-4 col-sm-6 col-md-4"
              data-aos="fade-up"
              data-aos-duration={600}
            >
              <div className="info-two-item flex-align animation-item h-100  border border-neutral-30 rounded-12 bg-main-two-25">
                <span className="flex-shrink-0">
                  <img
                    src="assets/images/icons/info-two-icon2.png"
                    className="animate__heartBeat"
                    alt=""
                  />
                </span>
                <div>
                  <h5 className="mb-16">Multi-Dimensional Development</h5>
                  <p className="text-neutral-700">
                    We nurture curiosity, resilience, responsibility,
                    well-being, and creativity in every student, shaping them
                    into confident, capable, and ethical global citizens.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="col-xl-4 col-sm-6 col-md-4"
              data-aos="fade-up"
              data-aos-duration={800}
            >
              <div className="info-two-item flex-align animation-item h-100  border border-neutral-30 rounded-12 bg-main-three-25">
                <span className="flex-shrink-0">
                  <img
                    src="assets/images/icons/info-two-icon3.png"
                    className="animate__heartBeat"
                    alt=""
                  />
                </span>
                <div>
                  <h5 className="mb-16">Academic Excellence</h5>
                  <p className="text-neutral-700">
                    Encourage curiosity and critical thinking through a rich and
                    engaging curriculum designed to build a strong academic
                    foundation.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfoTwo;
